import React from "react"
import { Link } from "gatsby"
import mcnimbus from "../../content/images/mcnimbus_dark_194.png"

const Navigation = props => (
  <nav className="nav">
    <div className="nav-container">
      <div className="brand">
        <Link to="/">
          <img src={mcnimbus} className="favicon" alt="McNimbus Logo" />
          <span className="text">mcnimbus.org</span>
        </Link>
      </div>
      <div className="links">
        {props.menuLinks.map(link => (
          <Link key={link.name} to={link.link} activeClassName="active">
            {link.name}
          </Link>
        ))}
      </div>
    </div>
  </nav>
)

export default Navigation
